import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { HouseIcon } from '@phosphor-icons/react';
import { Route as pathlessAuthenticatedRoute } from '../route';
import { homeSearchSchema } from './homeSearch';

const HomePage = lazyRouteComponent(() => import('./HomePage'), 'HomePage');

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/home',
  staticData: {
    app: {
      nav: {
        label: msg('Home', {
          context: 'sidebar nav label, Overview section',
        }),
        icon: <HouseIcon className="h-4 w-4" />,
        group: 'Overview',
        pinned: true,
        // Pinned entries sort by `order` (Chat is 0); -1 keeps Home first.
        // Its group also titles the pinned section, so it reads "Overview".
        order: -1,
        groupOrder: 0,
      },
    },
  },
  component: HomePage,
  validateSearch: homeSearchSchema,
  loader: () => ({
    crumb: msg('Home', { context: 'page breadcrumb' }),
  }),
});
